import logo from './newLogo.svg';

export const Logo = () => {

    return (
        <img
            src={logo}
        >
        </img>
    );
}